import React from "react";

import {Typography} from "@mui/material";
import {typografNode} from "../../utils/typograf";
import {SxProps} from "@mui/material/styles";

type H1Props = {
    children: React.ReactNode;
    sx?: SxProps;
    allowShortLastWordWrap?: boolean;
};

function H1({children, sx, allowShortLastWordWrap}: H1Props) {
    return (
        <Typography component="h1" variant="h1" sx={{
            fontWeight: '950',
            fontFamily: 'Nexa, Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '44px',
                lineHeight: 1.22,
            },
            '@media screen and (min-width: 1200px) and (max-width: 1399px)': {
                fontSize: '44px',
                lineHeight: 1.22,
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '40px',
                lineHeight: 1.3,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '40px',
                lineHeight: 1.22,
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '36px',
                lineHeight: 1.22,
            },
            '@media screen and (max-width: 575px)': {
                lineHeight: 1.22,
            },
            ...sx
        }}>
            {typografNode(children, allowShortLastWordWrap)}
        </Typography>
    );
}

export default H1
